import permissions from '../../permissions'

const GOVERNANCE_PROJECT_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.GOVERNANCE_PROJECT.LIST,
  },
  {
    name: 'Analisar Contestação com DAI',
    tag: permissions.GOVERNANCE_PROJECT.DAI_DISPUTE_ANALYSIS,
  },
]

export default GOVERNANCE_PROJECT_LIST
